module.exports = __webpack_public_path__ + "static/media/img4.d313fd65.jpg";